/*=========================================================================================
  File Name: store.js
  Description: Vuex store
  ----------------------------------------------------------------------------------------

==========================================================================================*/


import Vue from 'vue'
import Vuex from 'vuex'

import state from "./state"
import getters from "./getters"
import mutations from "./mutations"
import actions from "./actions"
import moduleEmail from './email/moduleEmail'
import loginModule from './login/loginModule'
import userManagement from './admin/user-management/moduleUserManagement'
import customer from './admin/customer'
import adminManagement from './admin/admin-management/moduleAdminManagement'
import mailServer from './admin/mail-server/moduleMailServer'
import passwordModule from "./password/passwordModule";
import receiveMail from './user/receiveMail/moduleReceiveMail'
import broadcast from './user/broadcast/moduleBroadcast'
import receiveTelephone from './user/receiveTelephone/moduleReceiveTelephone'
import mailSent from './user/mailSent/moduleMailSent'
import kinds from './admin/kinds/moduleKinds'
import subscriptions from './admin/subscription/index'
import customerDomain from './user/customerDomain/index'
import templateMail from './user/templateMail/moduleTemplateMail';
import mailDraft from './user/mailDraft/moduleMailDraft'
import settings from './admin/settings/moduleSettings'
import mailFolder from './user/mailFolder/moduleMailFolder'
import telephoneServer from './admin/telephone-server/moduleTelephoneServer'
import status from './admin/status/moduleStatus'
import userSetting from './user/userSetting/moduleUserSetting'
import notificationForSys from './user/notificationForSys/index'
import mailRule from './user/mailRule/moduleMailRule'
import userSignature from './user/userSignature/moduleUserSignature'
import mailError from './admin/mail-error/moduleMailError'
import company from './admin/company'
import mailSendResume from './admin/mail-send-resume/moduleMailSendResume'
import faqBbs from './faq-bbs/faqBbsModule'
import SecureLS from "secure-ls";
import dashBoard from './dashboard/moduleDashBoard';
import notification from './user/notification/moduleNotification';
import chatSetting from './chat-setting/chatSettingModule'
import mailSentFailed from './user/mailSentFailed/moduleMailSentFailed';
import mailBox from './admin/mail-box/moduleMailBox'
import contact from './user/contact'
import mailTrash from './user/mailTrash/moduleMailTrash'
const ls = new SecureLS({isCompression: false});

import createPersistedState from 'vuex-persistedstate'

Vue.use(Vuex)


const store = new Vuex.Store({
    getters,
    mutations,
    state,
    actions,
    modules: {
        // auth: moduleAuth,
        moduleEmail,
        loginModule,
        userManagement,
        notificationForSys,
        adminManagement,
        mailServer,
        passwordModule,
        receiveMail,
        broadcast,
        mailSent,
        kinds,
        templateMail,
        mailDraft,
        settings,
        mailFolder,
        userSetting,
        customer,
        mailRule,
        subscriptions,
        userSignature,
        mailError,
        company,
        mailSendResume,
        faqBbs,
        customerDomain,
        dashBoard,
        chatSetting,
        notification,
        mailSentFailed,
        telephoneServer,
        status,
        receiveTelephone,
        mailBox,
        contact,
        mailTrash
    },
    // //  encode local Storage
    plugins: [createPersistedState({
        /*storage: {
            getItem: key => ls.get(key),
            setItem: (key, value) => ls.set(key, value),
            removeItem: key => ls.remove(key)
        }*/
    })],
    // //  plugins: [createPersistedState()],
    strict: process.env.NODE_ENV !== 'production'
});

// Todo: check latter
// store.dispatch("browserSession/init");

export default store;
